import React from 'react'

export default () => <div style={{ width: '334px', height: '216px', overflowY: 'auto' }}>
  <a href="https://www.deepecom.com/" target="_blank" rel="noreferrer">
    <img src="/deepEcom.png" alt="DeepEcom" />
  </a>
</div>
